export default class ImagePopUp {
	constructor() {
		this.popup = document.querySelector(".image-pop-up");

		if (!this.popup) {
			return;
		}

		this.popUpImagesLinks = document.querySelectorAll(".image-pop-up-link");
		this.popupWrap = this.popup.querySelector(".wrap");
		this.popupContent = this.popup.querySelector(".pop-up-content");
		this.image = document.getElementById("pop-up-image");
		this.closeBtn = document.getElementById("image-pop-up-close");

		for (const link of this.popUpImagesLinks) {
			link.addEventListener("click", this.openPopUp.bind(this));
		}

		this.image.addEventListener("load", this.adjustPopUp.bind(this));

		this.closeBtn.addEventListener("click", this.closePopUp.bind(this));
		window.addEventListener("resize", this.adjustPopUp.bind(this));
	}

	openPopUp(e) {
		e.preventDefault();

		this.image.setAttribute("src", e.currentTarget.href);

		document.body.classList.add("pop-up-visible");
		this.popup.classList.add("is-loading");
	}

	adjustPopUp() {
		const contentStyle = window.getComputedStyle(this.popupContent);
		const borderLeft = parseInt(contentStyle.borderLeftWidth);
		const borderRight = parseInt(contentStyle.borderRightWidth);
		const borderTop = parseInt(contentStyle.borderTopWidth);
		const borderBottom = parseInt(contentStyle.borderBottomWidth);
		const maxWidth = this.popupWrap.offsetWidth - borderLeft - borderRight;
		const maxHeight = this.popupWrap.offsetHeight - borderTop - borderBottom;

		let width = this.image.naturalWidth,
			height = this.image.naturalHeight;

		if (width > maxWidth || height > maxHeight) {
			const wrapRatio = maxWidth / maxHeight;
			const imageRatio = this.image.naturalWidth / this.image.naturalHeight;

			if (wrapRatio > imageRatio) {
				height = maxHeight;
				width = height * imageRatio;
			} else {
				width = maxWidth;
				height = width / imageRatio;
			}
		}

		const setSize = () => {
			this.popup.classList.remove("is-loading");
			this.popupContent.removeEventListener("transitionend", setSize);
		};

		this.popupContent.style.width = `${width + borderLeft + borderRight}px`;
		this.popupContent.style.height = `${height + borderTop + borderBottom}px`;

		this.popupContent.addEventListener("transitionend", setSize);
	}

	closePopUp(e) {
		e.preventDefault();
		document.body.classList.remove("pop-up-visible");
	}
}
